import React from 'react'
import './Loading.css'

const Loading: React.FC = () => (
  <section className="loading-page">
    <div className="loading-card">
      <div className="loading-glow" aria-hidden="true" />
      <div className="loading-spinner" aria-label="Loading user data">
        <span />
        <span />
        <span />
      </div>
      <h1>Fetching all user data...</h1>
      <p>Chasing yarn threads</p>
    </div>
  </section>
)

export default Loading
